export const CONTACT_ALL_DEPARTMENT_KEY = 'all'
export const CONTACT_ALL_DEPARTMENT_LABEL = 'Tất cả phòng ban'
export const CONTACT_EMPTY_INITIAL = '?'

export const CONTACT_EMPLOYEE_EXPORT_CONFIG = {
  fileName: 'danh-sach-nhan-vien',
  fieldsToExport: [
    'name_uppercase',
    'email',
    'phone',
    'position.name',
    'department.name',
  ],
  headers: ['Tên', 'Email', 'Điện thoại', 'Chức vụ', 'Phòng ban'],
  columnWidths: [30, 30, 30, 30, 30],
}

export const getContactInitialName = user =>
  (
    user?.name_uppercase ||
    user?.name_lowercase ||
    user?.username ||
    CONTACT_EMPTY_INITIAL
  )
    .split('')[0]
    .toString()
    .toUpperCase()
